var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticClass:"left-menu",staticStyle:{"text-align":"left","height":"100%"},attrs:{"router":"","unique-opened":"","default-active":_vm.current}},[_c('MenuTree',{attrs:{"list":_vm.list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }